import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { DisplayProductsResult } from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { RealTimePricingModel } from "@insite/client-framework/Types/ApiModels";
import CustomApplicationState from "@tSchaedlerYesco/Store/CustomApplicationState";

export const addToPLPDataLayer = (
    state: CustomApplicationState,
    result: DisplayProductsResult,
    realTimePricing: RealTimePricingModel | null = null,
) => {
    const isSearchPage = state.pages.productList.isSearchPage;
    const category = getCategoryState(state, result.catalogPage?.categoryId).value;
    const products = result.products;
    const pricing = realTimePricing?.realTimePricingResults;

    if (!products?.length) {
        return;
    }

    const dataLayer = (window as any).dataLayer || [];
    dataLayer.push({ ecommerce: null });
    const data = {
        event: "view_item_list",
        ecommerce: {
            item_list_id: isSearchPage ? "Search" : category?.id,
            item_list_name: isSearchPage ? "Search" : category?.name,
            items: [] as any,
        },
    };

    for (let i = 0; i < products.length; i++) {
        const abc = pricing && pricing[i] ? pricing[i].actualPriceDisplay : "0.00";
        const extractedPrice = abc?.match(/[\d.]+/)?.[0] || "0.00";
        data.ecommerce.items.push({
            item_id: products[i].productNumber,
            item_name: products[i].productTitle,
            item_brand: products[i].brand?.name,
            price: extractedPrice,
            quantity: 1,
        });
    }
    dataLayer.push(data);
    console.log("view_item_list", dataLayer);
    return dataLayer;
};
